export const dialogOnBackPressHandlers = {
    data(){
        return {
            kimDialogs: []
        }
    },
    mounted(){
        // console.log('data', this.$data)
    },
    directives: {
        kimDialog: {
            inserted(el, binding, vnode) {

                const child = vnode.data.model ? vnode.data.model.expression
                    : vnode.componentInstance

                vnode.context.kimDialogs.push(child)

            }
        }
    },
    methods:{
        isClosableDialog(dialogComponent){

            var vm = this
            if(typeof dialogComponent === 'string'){
                return vm.$data[dialogComponent] === true
            }

            return dialogComponent.dialog === true

        },
        closeDialog(dialogComponent){

            var vm = this
            if(typeof dialogComponent === 'string'){
                if(!!vm.$data[dialogComponent]
                    && vm.$data[dialogComponent] === true){
                    vm.$data[dialogComponent] = false
                }
            }else{
                if(typeof dialogComponent.hide === 'function'
                    && dialogComponent.dialog === true){
                    dialogComponent.hide()
                }
            }

        }
    },
    beforeRouteLeave (to, from, next) {
        var vm = this
        var closableDialogs = 0

        if(vm.avoidDialogClose) return next()

        for(let dialogComponent of vm.kimDialogs){
            if(vm.isClosableDialog(dialogComponent)) closableDialogs++
        }

        if (closableDialogs > 0) {

            for(let dialogComponent of vm.kimDialogs){
                vm.closeDialog(dialogComponent)
            }

            next(false)
        } else {
            // console.log('no dialogs')
            next()
        }
    }
}

export function findVModelName(vnode) {
    return vnode.data.directives.find(function(o) {
        return o.name === 'model';
    }).expression;
}